import { render, staticRenderFns } from "./saticiortakbilgi.vue?vue&type=template&id=0f6a3019&"
import script from "./saticiortakbilgi.vue?vue&type=script&lang=js&"
export * from "./saticiortakbilgi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports